// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YQjO","toggleWrap":"styles_toggleWrap__fT8aP","content":"styles_content__3L-f_","selectAreaCode":"styles_selectAreaCode__2ep2k"};